export var Type = {
  Left: 'left',
  Right: 'right',
  Top: 'top',
  Bottom: 'bottom'
};